import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Button, Form, Image, Segment, Label } from "semantic-ui-react";
import CompanyImage from "../../../../resources/images/companyIcon.png";
import * as Yup from "yup";
import { Formik } from "formik";
import { FormInput, DropDownList, TextAreaField } from "../../../common";

class AddCompanyForm extends Component {
  state = {
    selectedValue: 0,
  };

  render() {
    const { company, onChange, companyErrors, onSubmitBtnClick, inputErrorClass, loader, onCancel, isLoading, roles } = this.props;
    const { selectedValue } = this.state;
    return (
      <div className="addComInner">
        <div className="AddCompanyFormCnt">
          <div className="AddCompanyFormInnerCnt">
            <h1>Add Company</h1>
            <span className="tagLine">Enter Company Name</span>
            <Image src={CompanyImage} size="small" className="addCompanyImage" />

            <Segment>
              <Form size="large" autoComplete="off" className={`${inputErrorClass(companyErrors.Name)}`}>
                <Formik
                  initialValues={{ email: "", password: "", roleId: "", companyName: "", ownerName: "", address: "", phoneNumber: "", registrationNumber: "" }}
                  onSubmit={(values) => onSubmitBtnClick(values)}
                  validationSchema={Yup.object().shape({
                    email: Yup.string()
                      .email(this.props.t("app.auth.validationInvalidEmail"))
                      .max(254, this.props.t("app.auth.validationMaxChars254"))
                      .required(this.props.t("app.auth.validationEmailRequired")),
                    password: Yup.string()
                      .min(6, this.props.t("app.auth.validationPasswordMin"))
                      .max(100, this.props.t("app.auth.validationMaxChars"))
                      .required(this.props.t("app.auth.validationPasswordRequired")),
                    roleId: Yup.string().required(this.props.t("app.auth.validationRequiredField")),
                    companyName: Yup.string()
                      .min(4, this.props.t("app.auth.validationCompanyNameMin"))
                      .max(200, this.props.t("app.auth.validationMaxChars200")),
                    ownerName: Yup.string()
                      .min(3, this.props.t("app.auth.validationOwnerNameMin"))
                      .max(200, this.props.t("app.auth.validationMaxChars200"))
                      .required(this.props.t("app.auth.validationOwnerNameRequired")),
                    registrationNumber: Yup.string()
                      .min(4, this.props.t("app.auth.validationCompanyNameMin"))
                      .max(200, this.props.t("app.auth.validationMaxChars200")),
                    phoneNumber: Yup.string()
                      .min(4, this.props.t("app.auth.validationCompanyNameMin"))
                      .max(30, this.props.t("app.auth.validationMaxChars30")),
                    address: Yup.string()
                      .min(4, this.props.t("app.auth.validationCompanyNameMin"))
                      .max(1000, this.props.t("app.auth.validationMaxChars1000"))
                  })}
                  render={({
                    values,
                    handleSubmit,
                    setFieldValue,
                    setFieldTouched,
                    errors,
                    touched,
                  }) => (
                    <div>
                      <div className="row">
                        <div className="col-sm" style={{ marginLeft: "10%", marginRight: "10%" }}>
                          {errors.ownerName && touched.ownerName && (
                            <Label>{errors.ownerName}</Label>
                          )}
                          <FormInput
                            style={{ textAlign: 'left' }}
                            value={values.ownerName}
                            fluid
                            placeholder={selectedValue === 1 ? 'Super Admin Name' : selectedValue === 2 ? 'Owner Name' : selectedValue === 3 ? 'Manager Name' : 'Name'}
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                            required
                            name="ownerName"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm" style={{ marginLeft: "10%", marginRight: "10%" }}>
                          {errors.email && touched.email && (
                            <Label>{errors.email}</Label>
                          )}
                          <FormInput
                            value={values.email}
                            placeholder="Email address"
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                            required
                            name="email"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm" style={{ marginLeft: "10%", marginRight: "10%", paddingBottom: "4%" }}>
                          {errors.password && touched.password && (
                            <Label style={{ marginTop: "5px" }}>
                              {errors.password}
                            </Label>
                          )}
                          <FormInput
                            value={values.password}
                            placeholder="Password"
                            type="password"
                            name="password"
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm" style={{ marginLeft: "10%", marginRight: "10%" }}>
                          {errors.roleId && touched.roleId && (
                            <Label style={{ marginTop: "5px" }}>
                              {errors.roleId}
                            </Label>
                          )}
                          <DropDownList
                            selection
                            value={values.roleId}
                            options={roles[0]}
                            fluid
                            placeholder="Select Role"
                            name="roleId"
                            onBlur={() => setFieldTouched("roleId", true)}
                            onChange={(e, { value }) => {
                              setFieldValue("roleId", value);
                              this.setState({ selectedValue: value });
                            }
                            }
                            loading={isLoading}
                          />
                        </div>
                      </div>
                      {selectedValue !== 1 ? (<div><div className="row">
                        <div className="col-sm" style={{ marginLeft: "10%", marginRight: "10%", paddingTop: '4%' }}>
                          {errors.companyName && touched.companyName && (
                            <Label>{errors.companyName}</Label>
                          )}
                          <FormInput
                            value={values.companyName}
                            placeholder="Company Name"
                            onChange={(event, data) =>
                              data && data.name
                                ? setFieldValue(data.name, data.value)
                                : ""
                            }
                            required
                            name="companyName"
                            type="text"
                          />
                        </div>
                      </div>


                        <div className="row">
                          <div className="col-sm" style={{ marginLeft: "10%", marginRight: "10%" }}>
                            {errors.registrationNumber && touched.registrationNumber && (
                              <Label>{errors.registrationNumber}</Label>
                            )}
                            <FormInput
                              value={values.registrationNumber}
                              placeholder="Registration Number"
                              onChange={(event, data) =>
                                data && data.name
                                  ? setFieldValue(data.name, data.value)
                                  : ""
                              }
                              required
                              name="registrationNumber"
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm" style={{ marginLeft: "10%", marginRight: "10%" }}>
                            {errors.phoneNumber && touched.phoneNumber && (
                              <Label>{errors.phoneNumber}</Label>
                            )}
                            <FormInput
                              value={values.phoneNumber}
                              placeholder="Phone Number"
                              onChange={(event, data) =>
                                data && data.name
                                  ? setFieldValue(data.name, data.value)
                                  : ""
                              }
                              required
                              name="phoneNumber"
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm" style={{ marginLeft: "10%", marginRight: "10%" }}>
                            {errors.address && touched.address && (
                              <Label>{errors.address}</Label>
                            )}
                            <TextAreaField
                              value={values.address}
                              placeholder="Address"
                              onChange={(event, data) =>
                                data && data.name
                                  ? setFieldValue(data.name, data.value)
                                  : ""
                              }
                              required
                              name="address"

                            />
                          </div>
                        </div></div>
                      ) : (null)}


                      <div className="row" style={{ paddingTop: '10%' }}>
                        <div className="col-sm text-center">
                          <Button
                            type="submit"
                            loading={isLoading}
                            primary
                            size="massive"
                            content="Submit"
                            className="addBtn"
                            onClick={() => handleSubmit(values)}
                          />

                          <Button
                            onClick={onCancel}
                            primary
                            size="massive"
                            content="Cancel"
                            className="cancelBtn"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                />
              </Form>
            </Segment>


          </div>
        </div>
      </div>
    )
  }

};
export default withTranslation()(AddCompanyForm);
